import { render, staticRenderFns } from "./ServiceCharge.vue?vue&type=template&id=67aea340&scoped=true"
import script from "./ServiceCharge.vue?vue&type=script&lang=ts"
export * from "./ServiceCharge.vue?vue&type=script&lang=ts"
import style0 from "./ServiceCharge.vue?vue&type=style&index=0&id=67aea340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67aea340",
  null
  
)

export default component.exports